import React, { useState, useEffect, useRef } from "react";
import { ModalControl } from "../common/modal/ModalRoot";
import "./SalesPitchModal.scss";
import { getSalesPitchScript } from "../../api/dashboard";
import Toast from "../common/Toasts/Toast";
import Loader from "../common/Loader";
import { Consumer } from "../../containers/Provider";
import Draggable from "../common/core/Draggable";
import { getGroupEntities } from "../../api/resource";

export default function SalesPinchModal(ownProps) {
  return (
    <Consumer>
      {(props) => (
        <ModalControl>
          {(control) => (
            <SalesPinchModalWithState
              {...ownProps}
              closeModal={control.closeModal}
              update={props.update}
              salesPitchHideVisibility={props.salesPitchHideVisibility}
              bussinessUnitSettings={props.bussinessUnitSettings}
              resourceId={props.profile?.resource?.id}
            />
          )}
        </ModalControl>
      )}
    </Consumer>
  );
}
function SalesPinchModalWithState(ownProps) {
  const [productList, setproductList] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [html, setHTML] = useState(null);
  const [loading, setloading] = useState(false);

  const toastRef = useRef();

  const showToast = (toast) => {
    toastRef.current.addToast({
      type: toast.type,
      message: toast.message,
    });
  };
  const salesPitch = async () => {
    setloading(true);
    const isSalesPitchBussinessAccess =
      ownProps.bussinessUnitSettings?.filter(
        (val) =>
          val.setting === "RESOURCE_GROUP_SALES_PITCH" &&
          val.settingValue === "true"
      )?.length > 0;
    let result;
    if (isSalesPitchBussinessAccess) {
      result = await getGroupEntities("sales_pitch", ownProps.resourceId);
    } else {
      result = await getSalesPitchScript();
    }
    setloading(false);
    if (result.status === 1) {
      let product = result.data?.map((val) => {
        return { label: val.pitchName, value: val.id, data: val.content };
      });
      setproductList(product);
    } else {
      showToast({
        type: "error",
        message: result.errorDescription
          ? result.errorDescription
          : "Something Went Wrong ",
      });
    }
  };

  const escFunction = (event) => {
    if (event.key === "Escape") {
      ownProps.update(
        {
          salesPitchHideVisibility: !ownProps.salesPitchHideVisibility,
        },
        () => {
          document.removeEventListener("keydown", escFunction, false);
        }
      );
    }
  };
  useEffect(() => {
    salesPitch();
    return () => {
      ownProps.update({
        salesPitchHideVisibility: false,
      });
    };
  }, []);
  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [ownProps.salesPitchHideVisibility]);
  return (
    <Draggable
      visibility={ownProps.salesPitchHideVisibility ? "hidden" : "visible"}>
      <div styleName={"base"}>
        {loading && <Loader />}
        <div styleName={"header"}>
          <div styleName={"header-text"}>Sales pitch</div>
          <div styleName="cross-icon" onClick={ownProps.closeModal} />
        </div>
        <div styleName={"content"}>
          {productList?.length > 0 ? (
            <div styleName={"input-holder"}>
              {productList?.map((val, i) => (
                <div
                  styleName={
                    selectedProduct === val.value ? "tag-active" : "tag"
                  }
                  key={i}
                  onClick={() => {
                    setSelectedProduct(val.value);
                    setHTML(val.data);
                  }}>
                  {val.label}
                </div>
              ))}
            </div>
          ) : (
            <div styleName="not-found">No Sales Pitch added</div>
          )}
          {html && (
            <div
              styleName="script-container"
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />
          )}
        </div>

        <Toast ref={toastRef} />
      </div>
    </Draggable>
  );
}
